/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RateCardUiDto } from '../models/rate-card-ui-dto';

@Injectable({
  providedIn: 'root',
})
export class RatecardService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getRateCardBySkuId
   */
  static readonly GetRateCardBySkuIdPath = '/api/v1/rateCard';

  /**
   * Get Rate Card.
   *
   * This API is used to fetch rate card for the specified SKU id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRateCardBySkuId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRateCardBySkuId$Response(params: {
    skuId: string;
  }): Observable<StrictHttpResponse<Array<RateCardUiDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RatecardService.GetRateCardBySkuIdPath, 'get');
    if (params) {
      rb.query('skuId', params.skuId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RateCardUiDto>>;
      })
    );
  }

  /**
   * Get Rate Card.
   *
   * This API is used to fetch rate card for the specified SKU id.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRateCardBySkuId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRateCardBySkuId(params: {
    skuId: string;
  }): Observable<Array<RateCardUiDto>> {

    return this.getRateCardBySkuId$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RateCardUiDto>>) => r.body as Array<RateCardUiDto>)
    );
  }

}
